<template>
    <div>
        <p v-if="shouldShowNoAvailableFiltersText(filter)">{{ filter.noAvailableFiltersText }}</p>

        <v-row>
            <v-col cols="3" v-for="filterValue in filter.values" :key="filterValue.value">
                <v-btn small class="pa-0 full-height-width" text @click="toggleValue(filterValue)">
                    <v-avatar rounded :class="{ selected: selectedFilterValues.includes(filterValue.value) }">
                        <v-avatar rounded :color="filterValue.color" :title="filterValue.value" class="inner" :style="style(filterValue)">
                            <v-img v-if="filterValue.image" :src="filterValue.image">
                                <template #placeholder>
                                    <v-icon v-if="filter.type === 'image'" color="grey">{{ mdiImageArea }}</v-icon>
                                    <v-icon v-else-if="!filterValue.color" color="grey">{{ mdiHelp }}</v-icon>
                                </template>
                            </v-img>

                            <v-icon v-if="!filterValue.image && !filterValue.color" color="grey">{{ mdiHelp }}</v-icon>
                        </v-avatar>
                    </v-avatar>
                    <div class="full-height-width text-caption text-none text-truncate">
                        {{ filterValue.value }}
                    </div>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>
<script lang="ts">
import { FilterMetadata } from '../../../../../declarations/result';
import { xor } from 'lodash-es';
import { Vue } from 'vue-property-decorator';
import TextFilterMixin from './TextFilterMixin.vue';
import { mdiHelp, mdiImageArea } from '@mdi/js';

export default Vue.extend({
    name: 'ColorImageFilter',
    mixins: [TextFilterMixin],
    methods: {
        style(filterValue: FilterMetadata): Partial<CSSStyleDeclaration> {
            const color = filterValue.color && filterValue.color !== '#FFFFFF' ? filterValue.color : '#333333';

            return { border: `2px solid ${color}33 !important` };
        },
        toggleValue(filterValue: FilterMetadata): void {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore TS does not recognize this value provided by the mixin, but WebStorm and the tests do. Fix later.
            this.selectedFilterValues = xor(this.selectedFilterValues, [filterValue.value]);
        },
    },
    data() {
        return {
            mdiImageArea,
            mdiHelp,
        };
    },
});
</script>

<style lang="scss" scoped>
.selected {
    border: 1px solid #555 !important;
}

::v-deep .v-btn__content {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.full-height-width {
    height: 100% !important;
    width: 100% !important;
}
</style>
